import React, { Component } from 'react';
import { Table,Tabs,Button,Pagination,Input, Row, Col,Select,Modal,Form,DatePicker,message,Radio, Breadcrumb,Tag} from 'antd';
import { connect } from 'react-redux';
import '@/css/question_package.less'


import {getCheckBeyondLevelListAPI,modifyCheckBeyondLevelStatusAPI,getCheckBeyondLevelUserListAPI} from '@/API'
import {tabList,tableColumns} from './constData'
import {WrappedCreateTaskForm} from './modal/create_task'
import {WrappedAssignBeyondCheckUserForm} from './modal/assign_check_user'
import {WrappedExportTaskStatsForm} from './modal/export_task_stats'



const Search = Input.Search,
	  Option = Select.Option,
	  confirm = Modal.confirm,
	  FormItem = Form.Item,
	  TabPane = Tabs.TabPane,
	  RadioGroup = Radio.Group;


export  class CheckBeyondLevelList extends Component{
	static contextTypes={
	    router: React.PropTypes.object.isRequired,
	    dispatch: React.PropTypes.func.isRequired
	}
	
	constructor(props) {
	    super(props);
	    this.state={
	       listQuery:{
	       		check_user:undefined,//审查人
	       		search:undefined,//查询关键字
	       		stage_type:'checking',//tab状态
	       		page:1,
	       		pagesize:10,
	       },
	       tasklist:[],
	       total:0,
	       loading:false,
	       openCreate:false,
	       openAssign:false,
	       openExport:false,
	       selectedRowKeys:[],
	       checkUserList:[],
	       id:'',
	    }

    }
   

    componentDidMount(){
    		this.getCheckBeyondLevelList()
        this.getCheckBeyondLevelUserList()
    }

    handleFilterChange(value,type){
    		let listQuery=this.state.listQuery
    		listQuery[type]=value
    		this.setState({listQuery})
    }

    getCheckBeyondLevelList=()=>{
    		this.setState({
    			loading:true,
    			taskList:[],
    			selectedRowKeys:[],
    		})
    		getCheckBeyondLevelListAPI(this.state.listQuery).then(res=>{
    				let data=res.data
    				this.setState({
    					taskList:data.list,
    					total:data.total,
    					loading:false
    				})
    				
    		}).catch(e=>{
    			this.setState({
	    			loading:false
	    		})
    		})
    }
    getCheckBeyondLevelUserList(){
    		getCheckBeyondLevelUserListAPI().then(res=>{
    			this.setState({checkUserList:res.data})
    		})
    }
    handleSearch=()=>{
    		this.getCheckBeyondLevelList()
    }
    handleReset=()=>{
    		let listQuery={
       		check_user:undefined,
       		search:undefined,//搜索关键字
       		stage_type:'checking',//tab状态
       		page:1,
       		pagesize:10,
       }
    	   this.setState({listQuery},()=>{
    	   		this.getCheckBeyondLevelList()
    	   })
    	   
    }

    renderFilter(){
    		const formItemLayout = {
	      labelCol: { span: 10 },
	      wrapperCol: { span: 14 },
	    };
	   let options=this.state.checkUserList.map(v=>{
	   		return(<Option value={v.id}  key={v.id}>{v.username}</Option>)
	   })
    		return(
    			 <Form
		      >
		        <Row gutter={40}>
		        		<Col  span={6}> 
		       			<FormItem {...formItemLayout} label="审查人">
		       			<Select
		       				showSearch
					        value={this.state.listQuery.check_user}
					        defaultActiveFirstOption={false}
					        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
					        onChange={(value)=>this.handleFilterChange(value,'check_user')}
					      >
		       				{options}
		       			 </Select>
		       			</FormItem>
					 </Col>
		        		<Col span={6}> 
		        		<FormItem {...formItemLayout} label="任务ID/任务名">
			        		<Input
			        			value={this.state.listQuery.search}
						    onChange={e =>this.handleFilterChange(e.target.value,'search')}
						  />
		        		</FormItem>
		        		</Col>
		        		 <Col span={6} style={{ textAlign: 'right' }}>
			            <Button type="primary" onClick={this.handleSearch}>查询</Button>
			            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>清空</Button>
			         </Col>
		        </Row>
		      </Form>
    		)
    }
    tabChange=(value)=>{
    		let  {listQuery}=this.state
    		listQuery.stage_type=value
    		listQuery.page=1
    		this.setState({listQuery})
    		this.getCheckBeyondLevelList()
    }
    onPageChange=(val)=>{
    		let {listQuery}=this.state
    		listQuery.page=val
    		this.setState({listQuery})
    		this.getCheckBeyondLevelList()
    }

    handleOpenModal(openKey){
    		this.setState({[openKey]:true})
    }
    //各修改状态操作 提交、删除
    handleConfirmModifyStatus(modifyType){
    		//todo stage modifytype  
    		let messageMapList={
    			submit:'确保任务中每道题目已查超纲！',
    			delete:'确认【删除】选中任务吗？',
    		}
    		let self=this
    		confirm({
		    title: messageMapList[modifyType],
		    onOk() {
		      	self.modifyCheckBeyondLevelStatus(modifyType)
		    }
		  });
    		
    }
    modifyCheckBeyondLevelStatus(modifyType){
    		let {stage_type}=this.state.listQuery
    		let params={task_id:this.state.selectedRowKeys}
    		modifyCheckBeyondLevelStatusAPI(stage_type,modifyType,params).then(res=>{
    			message.success('操作成功！')
    			this.getCheckBeyondLevelList()
    		})
    }

    handleClose=(closeType)=>{
    		this.setState({openCreate:false,openAssign:false,openExport:false})
    		closeType=='update'?this.getCheckBeyondLevelList():null
    }

    
    onSelectChange = (selectedRowKeys) => {
	    this.setState({ selectedRowKeys });
	}
	renderTab(){
		let {stage_type}=this.state.listQuery
		
		let {selectedRowKeys}=this.state
		const hasSelected = selectedRowKeys.length > 0;
		
		//按钮权限
		let btnAuth={}
		//tab权限
		if(this.props.user.role_qcheck){
			let authList=this.props.user.role_qcheck.columns.map(v=>{
				return v.stage_type
			})
			btnAuth=this.props.user.role_qcheck.buttons
			tabList.map((v,i)=>{
				authList.includes(v.key)?v.hidden=false:v.hidden=true
				return v
			})
		}
		//btn可用，由state_type和权限共同决定

		let  createAble=['checking'].includes(stage_type)&&btnAuth.taskAdd,//创建
			 assignCheckerAble=['checking'].includes(stage_type)&&btnAuth.taskAssign,//分配审核人
			 submitTaskAble=['checking','check_finish'].includes(stage_type),//提交
			 deleteAble=['checking'].includes(stage_type)&&btnAuth.taskDel,//删除
			 statsAble=['checking'].includes(stage_type)&&btnAuth.statistics//统计
		
		//btn权限部分
		switch (stage_type){
			case 'checking':
				submitTaskAble=submitTaskAble&&btnAuth.taskSbumit
				break;
			case 'check_finish':
				submitTaskAble=submitTaskAble&&btnAuth.online
				break;
			default:
				break;
		}

		let tabPane=tabList.map(v=>{
				if(!v.hidden){
					return(
						<TabPane tab={v.name} key={v.key}></TabPane>
					)
				}
				
		})
		return(
			<div >
				<Tabs   type="card" activeKey={stage_type} onChange={this.tabChange}>
			    		{tabPane}
				</Tabs>
				<div>
					<div style={{display:'inline-block',width:'50%'}}>
					{!!createAble&&<Button className="tabFuncBtn" onClick={()=>this.handleOpenModal('openCreate')}>创建任务</Button>}
					{!!assignCheckerAble&&<Button  disabled={!hasSelected} className="tabFuncBtn" onClick={()=>this.handleOpenModal('openAssign')}>分配审查人</Button>}
					{!!submitTaskAble&&<Button  disabled={!hasSelected} className="tabFuncBtn" onClick={()=>this.handleConfirmModifyStatus('submit')}>提交</Button>}
					{!!deleteAble&&<Button  disabled={!hasSelected} className="tabFuncBtn" onClick={()=>this.handleConfirmModifyStatus('delete')}>删除</Button>}
					{hasSelected&&<span style={{ marginLeft: 8,fontSize:'12px' }}>
			            <Tag color="orange">已勾选{selectedRowKeys.length}条</Tag>
			        </span>}
					</div>
					{!!statsAble&&<div style={{textAlign:'right',display:'inline-block',width:'50%'}}><Button type="primary"  className="tabFuncBtn" onClick={()=>this.handleOpenModal('openExport')}>入库任务统计</Button></div>}
				</div>
			</div>
		)
		
	}
	
	renderTable(){
		let columns=tableColumns

		let {selectedRowKeys,taskList}=this.state
		const rowSelection = {
	      selectedRowKeys,
	      onChange: this.onSelectChange,
	    };

		//table columns权限
		if(this.props.user.role_qcheck){
			let showColumsList=this.props.user.role_qcheck.columns.filter((v,i)=>{
				return v.stage_type==this.state.listQuery.stage_type
			})[0].columns
			
			let self=this
			columns=columns.filter((v,i)=>{
				return showColumsList.includes(v.key)
			})
		}
		return(
			<Table scroll={{ x: true }} rowSelection={rowSelection} loading={this.state.loading} rowKey={record=>record.task_id} pagination={false} columns={columns} dataSource={taskList} />
		)
	}
    render(){
		let {total,openCreate,checkUserList,selectedRowKeys,openAssign,openExport,listQuery}=this.state

			return(
	            <div >
	                <Breadcrumb className="breadCrumb">
	                    <Breadcrumb.Item  className="breadItem" ><span>题目管理</span></Breadcrumb.Item>
	                    <Breadcrumb.Item className="breadItem"><span>查超纲</span></Breadcrumb.Item> 
	                </Breadcrumb>  
	                 <div>
	                 	{this.renderFilter()}
	                 	{this.renderTab()}
	                 	{this.renderTable()}
	                 	<div style={{textAlign:'right',margin:'20px'}}><Pagination showQuickJumper current={listQuery.page} total={total} onChange={this.onPageChange} /></div>
	                 </div>
	                 <WrappedCreateTaskForm checkUserList={checkUserList} openCreate={openCreate} handleClose={this.handleClose}/>
	                 <WrappedAssignBeyondCheckUserForm checkUserList={checkUserList} openAssign={openAssign} taskId={selectedRowKeys} handleClose={this.handleClose}/>
	                 <WrappedExportTaskStatsForm openExport={openExport} handleClose={this.handleClose}/>
	            </div>
	       );
    }

}

const mapStateToProps = (state) => {
    return {    
        user:state.user,
    };
}

export default connect(mapStateToProps)(CheckBeyondLevelList);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/check_beyond_level_list.js